import { useSyncExternalStore } from "react";
import { historyStore } from "../store/historyStore";

// 訂閱 historyStore，讓組件即時更新
export const useHistory = () => {
  return useSyncExternalStore(historyStore.subscribe.bind(historyStore), () =>
    historyStore.getHistory()
  );
};
